<template>
    <div class="slu-student-course-card">
        <div class="header">
            <img :src="courseIn.image" :alt="`${courseIn.name} banner`">

            <div class="module-chart">
                <design-2021-apprentice-pie-chart-component :options="radialBarData.options"
                                                            :series="radialBarData.series"
                                                            :height="200">
                </design-2021-apprentice-pie-chart-component>
            </div>
        </div>

        <div class="body">
            <div class="title">
                {{ courseIn.name }}
            </div>

            <div class="slu-points-progress">
                {{ `${courseIn.completedHours / sluSchoolSettingsIn.hours_to_point}/${courseIn.totalHours / this.sluSchoolSettingsIn.hours_to_point} ${this.sluSchoolSettingsIn.name_points}`}}
            </div>

            <div class="slu-bonus-points" v-if="courseIn.totalBonusHours > 0">
                {{ `+ ${courseIn.completedBonusHours / sluSchoolSettingsIn.hours_to_point}/${courseIn.totalBonusHours / this.sluSchoolSettingsIn.hours_to_point} ${this.sluSchoolSettingsIn.name_points}`}}
            </div>
        </div>
        <a @click.prevent.stop="ShowCourseDetail" class="clickable"></a>
    </div>
</template>

<script>
export default {
    name: "design-2021-slu-student-course-card-component",
    props: {
        courseIn: {
            type: Object,
            required: true,
        },
        sluStudentIn: {
            type: Object,
            required: true,
        },
        sluSchoolSettingsIn: {
            type: Object,
            required: false,
        },
        selectedSeasonIdIn: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            offSetY: -5,
        }
    },
    computed: {
        radialBarData() {
            let open = 0;
            let completed = 0;
            let rejected = 0;

            for(const cohort of this.sluStudentIn.slu_cohorts){
                if(this.courseIn.id === cohort.slu_course_id) {
                    if(this.selectedSeasonIdIn === 0 || this.selectedSeasonIdIn === cohort.season_id){
                        for(const module of cohort.modules){
                            if(module.required){
                                if(module.slu_module_records.length === 0){
                                    open += module.hours;
                                } else {
                                    if(module.slu_module_records[0].completed === 1) {
                                        completed += module.hours;
                                    } else if(module.slu_module_records[0].completed === 0 && module.slu_module_records[0].slu_status_tag_id === null) {
                                        open += module.hours;
                                    } else {
                                        rejected += module.hours;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            let completedPoints = 0;
            let totalPoints = 0;
            const namePoints = this.sluSchoolSettingsIn.name_points;

            let series = [];
            let colors = [];
            let labels = [];

            if(open === 0 && completed === 0 && rejected === 0){
                series.push(0);
                colors.push('#5c6369');
                labels.push(this.$t('slu_dashboard.basic_modules_open'));
            } else {
                completedPoints = (1 * (completed / this.sluSchoolSettingsIn.hours_to_point).toFixed(1));
                const remainingPoints = (1 * (open / this.sluSchoolSettingsIn.hours_to_point).toFixed(1));
                const rejectedPoints = (1 * (rejected / this.sluSchoolSettingsIn.hours_to_point).toFixed(1));
                totalPoints = (1 * (this.courseIn.totalHours / this.sluSchoolSettingsIn.hours_to_point).toFixed(1));

                if (completedPoints !== 0) {
                    series.push(completedPoints);
                    colors.push('#61CC13');
                    labels.push(this.$t('slu_dashboard.basic_modules_achieved'));
                }

                if (open !== 0) {
                    series.push(remainingPoints);
                    colors.push('#5c6369');
                    labels.push(this.$t('slu_dashboard.basic_modules_open'));
                }

                if (rejected !== 0) {
                    series.push(rejectedPoints);
                    colors.push('#FF0046');
                    labels.push(this.$t('slu_dashboard.basic_modules_rejected'));
                }
            }

            return {
                series: series,
                options: {
                    chart: {
                        type: 'donut',
                        width: '100%',
                    },
                    colors: colors,
                    labels: labels,
                    dataLabels: {
                        enabled: false
                    },
                    plotOptions: {
                        pie: {
                            expandOnClick: false,
                          donut:{
                                background: '#F2FAFF',
                              size: '75%',
                              labels:{
                                  show: true,
                                  name: {
                                      show: false,
                                      fontSize: '12px',
                                      fontFamily: 'DM Sans',
                                      fontWeight: 500,
                                      color: '#212529',
                                      offsetY: -10,
                                      formatter: function (value){
                                          return '';
                                      }
                                  },
                                  value: {
                                      show: true,
                                      fontFamily: 'DM Sans, sans-serif',
                                      fontSize: '21px',
                                      fontWeight: 500,
                                      color: '#212529',
                                      offsetY: 5,
                                      formatter: function (val){
                                          return val + ' ' + namePoints;
                                      }
                                  },
                                  total: {
                                      show: true,
                                      label: '',
                                      color: '#ffa500',
                                      formatter: function () {
                                          const pointsPercentage = completedPoints === 0 && totalPoints === 0 ? 0 : completedPoints / totalPoints * 100;
                                          return `${(pointsPercentage).toFixed(0)}%`;
                                      }
                                  },
                              }
                          }
                        },
                    },
                    tooltip: {
                        enabled: true,
                        custom: function({ series, seriesIndex, dataPointIndex, w }) {
                            let labels = w.globals.labels[seriesIndex].split(' ');
                            labels.splice(1, 0, series[seriesIndex]);
                            labels.splice(2, 0, namePoints);

                            return (
                                `<div class="arrow_box" style="background-color: ${w.globals.colors[seriesIndex]}; padding: 4px;">` +
                                "<span>" +
                                labels.join(' ') +
                                "</span>" +
                                "</div>"
                            );
                        }
                    },
                    legend: {
                        show: false
                    },
                }
            }
        },

        hasModeleForSelectedSeason(){
            let hasModules = false;
            for(const cohort of this.sluStudentIn.slu_cohorts) {
                if (this.courseIn.id === cohort.slu_course_id) {
                    if (this.selectedSeasonIdIn === 0 || this.selectedSeasonIdIn === cohort.season_id) {
                        hasModules = true;
                        break;
                    }
                }
            }

            return hasModules;
        }
    },

    methods: {
        ShowCourseDetail() {
            if (this.$authUser.isAdmin() || this.$authUser.isTeacher()) {
                window.location.href = this.routes.sluStudentCourse(this.sluStudentIn.id, this.courseIn.id);
            } else {
                window.location.href = this.routes.studentSluCourse(this.courseIn.id);
            }
        }
    }
}
</script>

<style scoped lang="scss">
.slu-student-course-card {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 100%;
    border: 1px solid $border-color;
    border-radius: $border-radius-content;

    .header {
        width: 100%;
        height: 150px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
            border-top-left-radius: $border-radius-content;;
            border-top-right-radius: $border-radius-content;;
        }
    }

    .module-chart {
        position: relative;
        align-self: center;
        width: 200px;
        top: -79px;
        left: calc(50% - 100px);
        z-index: 10;
    }

    .body {
        padding: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'twenty-one');
        width: 100%;
        text-align: center;
    }

    .title {
        font-family: $headings-font-family;
        font-weight: $font-weight-bold;
        font-size: 1.3125rem;
        margin-top: 90px;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        word-break: break-word;
    }

    .slu-points-progress,
    .slu-bonus-points {
        color: $text-muted-color;
        font-weight: $font-weight-bold;
        font-size: 1.125rem;
        line-height: 1.5;
    }

    .total-slu,
    .total-modules,
    .bonus-hours {
        color: $text-muted-color;
        font-weight: $font-weight-medium;
        line-height: 1.5;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }

    .actions {
        margin-top: auto;
        display: flex;
        flex-direction: column;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');
        width: 100%;

        .btn {
            font-size: $default-font-size;
            z-index: 10;

            &:not(:last-child) {
                margin-bottom: map-get($grid-gutter-spacing, 'ten');
            }
        }
    }

    &:hover {
        cursor: pointer;
        border-bottom-left-radius: $border-radius-content;
        border-bottom-right-radius: $border-radius-content;
        box-shadow: 0 3px 21px 0 rgb(0 0 0 / 10%), 0 1px 8px 0 rgb(0 0 0 / 5%);
    }
}

@media(min-width: map-get($grid-breakpoints, 'md')) {
    .slu-student-course-card {
        .actions {
            flex-direction: row;

            .btn {
                &:not(:last-child) {
                    margin-bottom: 0;
                }
            }
        }

        .body {
            height: calc(100% - 150px);
        }
    }
}
</style>
